export enum DocumentType {
    PDF = 71,
    Word = 83
}